module.exports = __webpack_public_path__ + "img/huifu.d48df075.png";